import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { AuthorizerService } from '@vcomply/authorizer'
import { UtilityService } from 'src/app/services/utility.service'
import { HREF_CONSTANTS } from 'src/app/shared/constants/href-constant'

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.less'],
})
export class SigninComponent implements OnInit {
  viewState: 'SIGN_IN' | 'MFA' | 'RECOVERY_PIN' | 'AD_REDIRECT' = 'SIGN_IN'
  MFAData!: any
  constructor(private utility: UtilityService, private route: ActivatedRoute) {}
  prePopulatedMail!: any
  redirectURL = ''
  ngOnInit(): void {
    this.prePopulatedMail = this.route.snapshot.queryParamMap.get('email_id')
    this.redirectURL = this.route.snapshot.queryParams['redirectURL']
  }

  /**
   * After login state
   * @param loginInfo data returned after sucessful login
   */
  afterLoginState(loginInfo: any) {
    if (loginInfo && loginInfo?.token) {
      this.setToken(loginInfo?.token)
    } else if (loginInfo && loginInfo?.isMFAEnabled) {
      this.MFAData = loginInfo
      this.viewState = 'MFA'
    }
  }

  afterMfaVerified(token: any) {
    if (token?.token) {
      this.setToken(token?.token)
    }
  }
  /**
   * Sets token in local storage
   * @param token the JWT token string
   */
  setToken(token: string) {
    this.utility.removeSearchHistory()
    if (this.prePopulatedMail) {
      const currentUser = localStorage.getItem('currentUser')
      const obj = { token }
      if (currentUser) {
        localStorage.setItem('primaryuser', currentUser)
        localStorage.setItem('currentUser', JSON.stringify(obj))
        this.redirectAfterLogin()
      } else {
        localStorage.setItem('currentUser', JSON.stringify(obj))
        this.redirectAfterLogin()
      }
    } else {
      const obj = { token }
      localStorage.removeItem('currentUser')
      localStorage.setItem('currentUser', JSON.stringify(obj))
      this.redirectAfterLogin()
    }
  }

  redirectAfterLogin() {
    if (window.location.href.includes(HREF_CONSTANTS.INTEGRATION_OUTLOOK) || window.location.href.includes(HREF_CONSTANTS.INTEGRATION_WORD)) {
      this.utility.redirectToIntegration()
    } else {
      if (this.redirectURL) {
        window.location.href = decodeURIComponent(this.redirectURL)
      } else {
        this.utility.redirectTo('DASHBOARD')
      }
    }
  }

  redirectToAD(subdomain: string) {
    this.viewState = 'AD_REDIRECT'
    setTimeout(() => {
      window.location.href = `https://${subdomain}.v-comply.com/`
    }, 1000)
  }
}
